import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width={40} height={40} rx={20} fill={theme["#B4E3E1"]} />
            <path
                d="M23.5 27.5c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 001.092-1.092c.273-.535.273-1.235.273-2.635v-7c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 00-1.092-1.092C25.6 12.5 24.9 12.5 23.5 12.5h-7c-1.4 0-2.1 0-2.635.273a2.5 2.5 0 00-1.092 1.092C12.5 14.4 12.5 15.1 12.5 16.5v7c0 1.4 0 2.1.273 2.635a2.5 2.5 0 001.092 1.092c.535.273 1.235.273 2.635.273h7z"
                stroke={theme["#0D968F"]}
                strokeWidth={1.66667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.443 20.996c-.059-.177-.088-.265-.087-.337a.352.352 0 01.047-.183c.033-.064.122-.147.3-.312a2.5 2.5 0 10-3.405 0c.177.165.266.248.299.312a.352.352 0 01.047.183c.001.072-.028.16-.087.337l-.764 2.293c-.1.296-.149.445-.119.563.026.103.09.192.18.25.102.065.259.065.571.065h3.15c.312 0 .469 0 .571-.066a.417.417 0 00.18-.25c.03-.117-.02-.266-.119-.562l-.764-2.293z"
                stroke={theme["#0D968F"]}
                strokeWidth={1.66667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
  
  export default SvgComponent